import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";

function AltaClientePredeterminado(props) {
  const [alta, setAlta] = useState(props.alta);
  const [datosRow, setDatosRow] = useState({
    uso: "",
  });
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [sucursalesFiltradas, setSucursalesFiltradas] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");


  // Función para filtrar sucursales disponibles
  const filtrarSucursalesDisponibles = (sucursalesLista) => {
    if (!props.clientesPredeterminados || props.clientesPredeterminados.length === 0) {
      setSucursalesFiltradas(sucursalesLista);
      return;
    }

    // Obtener IDs de sucursales que ya tienen registro
    const idsOcupados = props.clientesPredeterminados.map(cliente => cliente.id_sucursal);
    
    // Filtrar sucursales que NO están en idsOcupados
    const disponibles = sucursalesLista.filter(
      sucursal => !idsOcupados.includes(sucursal.id)
    );
    
    setSucursalesFiltradas(disponibles);
  };

  useEffect(() => {
    getData(
      "/sucursales/xsucauth/" + localStorage.getItem("suc_auth").split(","),
      (data) => {
        setSucursales(data);
        // Filtrar sucursales que ya tienen registro
        filtrarSucursalesDisponibles(data);
      }
    );
  }, []);

  // Efecto para cuando cambien los clientes predeterminados
  useEffect(() => {
    if (sucursales.length > 0 && props.clientesPredeterminados) {
      filtrarSucursalesDisponibles(sucursales);
    }
  }, [props.clientesPredeterminados, sucursales]);

  // Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setAlta(!alta);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  const guardarSisvenId = async (e) => {
    setDisBtn(true);
    e.preventDefault();
    
    if (!sucursalSeleccionada) {
      setMensaje("Debe seleccionar una sucursal");
      setColorMensaje("#FFCCCC");
      setOpenSnack(true);
      setDisBtn(false);
      return;
    }

    await fetch(UrlApi + "/envasado_sisven_predeterminados", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_sucursal: sucursalSeleccionada.id,
        sisven_id: datosRow.sisven_id,
        usuario: localStorage.getItem("user"),
      }),
    })
      .then((res) => {
        if (!res.err) {
          console.log("Guardado");
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El Registro se guardó exitosamente !");
          
          // Limpiar formulario
          setDatosRow({ uso: "" });
          setSucursalSeleccionada("");
          setDisBtn(false);
        } else {
          console.log("Error");
          setMensaje("Error al guardar el registro");
          setColorMensaje("#FFCCCC");
          setOpenSnack(true);
          setDisBtn(false);
        }
      })
      .catch((err) => {
        console.log(err.message);
        setMensaje("Error de conexión: " + err.message);
        setColorMensaje("#FFCCCC");
        setOpenSnack(true);
        setDisBtn(false);
      });
  };

  return (
    <>
      <Dialog fullWidth open={alta} onClose={() => handleClose()} maxWidth="md">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Sisven ID predeterminado
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={guardarSisvenId}>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={6} py={1} mb={1}>
                <Autocomplete
                  disabled={!sucursalesFiltradas || sucursalesFiltradas.length === 0}
                  required
                  disableClearable
                  id="id_sucursal"
                  style={{ backgroundColor: "#ffffff", width: "100%" }}
                  size="small"
                  noOptionsText={"No hay sucursales disponibles"}
                  options={sucursalesFiltradas || []}
                  autoHighlight
                  getOptionLabel={(s) => s.id + " - " + s.nombre}
                  value={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setSucursalSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar sucursal..."
                      {...params}
                      label="Sucursal"
                      focused
                      required
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
                {sucursalesFiltradas.length === 0 && sucursales.length > 0 && (
                  <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                    Todas las sucursales ya tienen un registro asignado
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <TextField
                  label="Sisven ID"
                  name="sisven_id"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 300,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.sisven_id}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid>
                <Button
                  type="submit"
                  color="success"
                  variant="contained"
                  disabled={disBtn || sucursalesFiltradas.length === 0}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={colormensaje === "#D4EFDF" ? "success" : "error"}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AltaClientePredeterminado;